import React from "react";
import Text from "../typography/text";
import Button from "../button/button.component";

const NavItems = () => {
  const whatsappMessage = "Hii Tara I want to connect";

  const handleConnect = () => {
    window.open(
      `https://wa.me/+917229804925/?text=${whatsappMessage}`,
      "_blank"
    );
  };

  return (
    <div className="flex flex-col lg:flex-row gap-6 items-center">
      <a href="#home">
        <Text font="HeadingXSSmall" hover={"primary"}>
          Home
        </Text>
      </a>
      <a href="#team">
        <Text font="HeadingXSSmall" hover={"primary"}>
          Our Team
        </Text>
      </a>
      <a href="#service">
        <Text font="HeadingXSSmall" hover={"primary"}>
          Services
        </Text>
      </a>
      <a href="#product">
        <Text font="HeadingXSSmall" hover={"primary"}>
          Products
        </Text>
      </a>
      <a href="#about">
        <Text font="HeadingXSSmall" hover={"primary"}>
          About Us
        </Text>
      </a>
      <a href="#client-review">
        <Text font="HeadingXSSmall" hover={"primary"}>
          Client Reviews
        </Text>
      </a>
      <a href="#contact">
      <Button>Let's Connect</Button>
      </a>
    </div>
  );
};

export default NavItems;
